import { render } from "./Header.vue?vue&type=template&id=44093b4b&scoped=true"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"

import "./Header.vue?vue&type=style&index=0&id=44093b4b&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-44093b4b"

export default script